import { useMemo } from 'react'
import { mdiCheck } from '@mdi/js'
import { FormattedMessage } from 'react-intl'
import { DateTime } from 'luxon'

import {
  HomeStatusSystemAccess,
  StyledLabel,
  StyledTitle,
  HomeStatusSuccessBox,
  HomeStatusSuccessBoxIcon,
} from '../styles'

import { addTime } from 'app/utils/formatDate'
import { useAppDispatch } from 'app/hooks'
import { requestAccessThunk } from 'features/home/slice'
import RequestAccessButton from './RequestAccessButton'
import IntlFormattedDate from 'app/i18n/IntlFormattedDate'
import { homeAccessMessages } from './messages'
import theme from 'theme_'

interface HomeSystemAccessProps {
  configAccessExpires: number
  domainId: string
  id: string
  name: string
}

function HomeSystemAccess(props: HomeSystemAccessProps) {
  const { configAccessExpires, domainId, id, name } = props

  const dispatch = useAppDispatch()
  const homeAccessEnabled = configAccessExpires > Date.now()
  const isNeverExpiringAccess = useMemo(
    () =>
      DateTime.fromMillis(configAccessExpires) >
      DateTime.now().plus({ days: 3 }),
    [configAccessExpires]
  )

  const requestAccessHandler = () => {
    const configAccess = addTime(Date.now(), { years: 1 }).valueOf()

    return dispatch(
      requestAccessThunk(domainId, id, {
        configAccess,
      })
    )
  }

  // TODO Localization
  return (
    <HomeStatusSystemAccess>
      <StyledLabel>
        <FormattedMessage {...homeAccessMessages.systemAccess} />
      </StyledLabel>
      <StyledTitle>
        {homeAccessEnabled ? (
          <HomeStatusSuccessBox>
            <HomeStatusSuccessBoxIcon
              path={mdiCheck}
              size={0.8}
              color={theme.colors.successGreen}
            />
            {isNeverExpiringAccess ? (
              <FormattedMessage
                {...homeAccessMessages.systemAccessNeverExpire}
              />
            ) : (
              <>
                <FormattedMessage {...homeAccessMessages.systemAccessExpires} />{' '}
                <IntlFormattedDate date={configAccessExpires} withTime />
              </>
            )}
          </HomeStatusSuccessBox>
        ) : (
          <RequestAccessButton
            homeName={name}
            requestAccessHandler={requestAccessHandler}
          />
        )}
      </StyledTitle>
    </HomeStatusSystemAccess>
  )
}

export default HomeSystemAccess
